import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { imageUrl } from '../lib/images';
import { fetchCollection } from '../lib/cms';
import SEO from '../components/SEO';
import SparklePattern from '../components/SparklePattern';

export function ServicesOverview() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    fetchCollection('services').then((data) => {
      if (data && data.length > 0) {
        setServices(data);
      }
    });
  }, []);

  return (
    <>
      <SEO
        title="Service/Priser | MA Hvidevareservice"
        description="Priser og service hos MA Hvidevareservice. Servicebesøg + fejlfinding 995 kr. inkl. moms og udkørsel. 1–2 års garanti på udført arbejde og reservedele."
      />

      {/* Header section */}
      <section className="relative bg-white border-b border-slate-200/80 py-12 sm:py-16 overflow-hidden isolate">
        <SparklePattern variant="blue" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#53b7ff] tracking-tight">
              Service/Priser
            </h1>
          </div>
        </div>
      </section>

      {/* Pricing section with exact verbatim content from scrape */}
      <section className="py-14 sm:py-20 bg-slate-50 border-b border-slate-200/80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-[#53b7ff] tracking-tight">
              Priser
            </h2>
            <p className="text-sm font-bold text-sky-700 mt-1 uppercase tracking-wider">
              Alle priser er inkl. moms
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 mb-12">
            {/* Card 1: Servicebesøg */}
            <div className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8 shadow-sm flex flex-col justify-between">
              <div>
                <svg
                  className="w-10 h-10 sm:w-12 sm:h-12 text-[#38b6ff] mb-5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <h3 className="text-xl font-bold text-slate-900 mb-1">
                  Servicebesøg + fejlfinding
                </h3>
                <div className="text-3xl font-extrabold text-slate-900 my-4">
                  995 kr. <span className="text-xs font-normal text-slate-500">inkl. moms</span>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">
                  Dette inkluderer udkørsel, grundig fejlfinding og altid gratis prisoverslag på reparationen (jeg laver ALTID et skriftligt eller mundtligt overslag, før noget repareres – du beslutter selv, om vi går videre). kan det repareres uden reservedele inden for 30 minutter bliver det stadig kun 995 kr.
                </p>
              </div>
            </div>

            {/* Card 2: Ekstra tid */}
            <div className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8 shadow-sm flex flex-col justify-between">
              <div>
                <svg
                  className="w-10 h-10 sm:w-12 sm:h-12 text-[#38b6ff] mb-5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <h3 className="text-xl font-bold text-slate-900 mb-1">
                  Ekstra tid
                </h3>
                <div className="text-3xl font-extrabold text-slate-900 my-4">
                  200 kr. <span className="text-xs font-normal text-slate-500">pr. påbegyndt 30 min.</span>
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">
                  Ekstra tid udover fejlfinding/besøg 200 kr. pr. påbegyndt 30 minutter (Arbejdstid til selve reparationen, hvis du siger ja til at fortsætte.)
                </p>
              </div>
            </div>

            {/* Card 3: Reservedele */}
            <div className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8 shadow-sm flex flex-col justify-between">
              <div>
                <svg
                  className="w-10 h-10 sm:w-12 sm:h-12 text-[#38b6ff] mb-5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <h3 className="text-xl font-bold text-slate-900 mb-1">
                  Reservedele
                </h3>
                <div className="text-3xl font-extrabold text-slate-900 my-4">
                  Fair markedspris
                </div>
                <p className="text-sm text-slate-600 leading-relaxed">
                  Faktureres til fair markedspris + moms (jeg bruger kun originale eller kvalitetsgodkendte dele, og du får altid overslag på deleprisen først).
                </p>
              </div>
            </div>
          </div>

          {/* Vigtigt at vide sektion */}
          <div className="pt-2">
            <h3 className="text-xl sm:text-2xl font-bold text-slate-900 mb-4 sm:mb-5 flex items-center gap-2.5">
              <i className="fa-solid fa-circle-info text-[#38b6ff]" aria-hidden="true" />
              <span>Vigtigt at vide</span>
            </h3>

            <div className="flex flex-col space-y-2.5 sm:space-y-3 text-sm text-slate-700">
              <div className="flex items-start gap-3 py-1">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>
                  <strong>Prisoverslag laves ALTID inden reparation starter</strong> – ingen overraskelser!
                </span>
              </div>

              <div className="flex items-start gap-3 py-1">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>
                  Hvis reparationen ikke kan betale sig (f.eks. hvis maskinen er for gammel), siger jeg det ærligt, og du betaler kun for besøget (995 kr.).
                </span>
              </div>

              <div className="flex items-start gap-3 py-1">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>
                  <strong>Mulighed for servicefradrag via SKAT:</strong> Du kan få ca. 26% tilbage i skat på arbejdslønnen (op til loftet på ca. 18.300 kr. pr. person i 2026). Jeg hjælper gerne med dokumentation til din selvangivelse.
                </span>
              </div>

              <div className="flex items-start gap-3 py-1">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>
                  <strong>Betaling:</strong> MobilePay, kontant.
                </span>
              </div>

              <div className="flex items-start gap-3 py-1">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>
                  <strong>Garanti:</strong> 1–2 års garanti på udført arbejde og nye dele (afhængig af deltype).
                </span>
              </div>

              <div className="flex items-start gap-3 py-1">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>
                  <strong>Direkte kontakt:</strong> Du bliver kontaktet 20 minutter før vi ankommer.
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service oversigt */}
      <section className="py-14 sm:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#53b7ff] tracking-tight">
              Service
            </h2>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-700 leading-relaxed">
              <li className="flex items-start gap-2.5">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>Fejlfinding og udskiftning af reservedele (ofte med reservedele med på servicevognen → hurtig fiksering ved første besøg)</span>
              </li>
              <li className="flex items-start gap-2.5">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>Serviceeftersyn og vedligehold</span>
              </li>
              <li className="flex items-start gap-2.5">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>Reparation på alle mærker (Bosch, Siemens, Miele, Electrolux, Whirlpool, Samsung, LG osv.)</span>
              </li>
              <li className="flex items-start gap-2.5">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>Service til både privatkunder, boligforeninger, erhverv, og institutioner</span>
              </li>
              <li className="flex items-start gap-2.5">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>Ofte hjemmebesøg inden for 1 dag.</span>
              </li>
              <li className="flex items-start gap-2.5">
                <svg
                  className="w-4 h-4 text-[#38b6ff] mt-0.5 shrink-0"
                  viewBox="0 0 100 100"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="7"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  aria-hidden="true"
                >
                  <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                </svg>
                <span>Jeg giver 1–2 års garanti på udført arbejde og nye dele</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="relative py-16 sm:py-20 bg-[#38b6ff] border-t border-b border-[#229ee6] overflow-hidden isolate">
        <SparklePattern variant="white" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {services.map((item, index) => {
              const numStr = String(index + 1).padStart(2, '0');
              return (
                <Link
                  key={item.id || item.service_key}
                  to={`/ydelser/${item.service_key}`}
                  className="group bg-white border border-slate-200/80 rounded-xl overflow-hidden shadow-sm flex flex-col justify-between block p-6"
                >
                  <div className="grid grid-cols-[auto_1fr] gap-6 sm:gap-7">
                    {/* Kolonne 1: Nummer i toppen, SVG i bunden */}
                    <div className="flex flex-col justify-between items-start py-0.5">
                      <span className="text-sm font-black text-slate-400 group-hover:text-[#38b6ff] transition-colors tracking-wider font-mono">
                        {numStr}
                      </span>
                      <svg
                        className="w-4 h-4 text-[#38b6ff] shrink-0 mt-4"
                        viewBox="0 0 100 100"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="7"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                        aria-hidden="true"
                      >
                        <path d="M 50 5 C 52 28, 72 48, 95 50 C 72 52, 52 72, 50 95 C 48 72, 28 52, 5 50 C 28 48, 48 28, 50 5 Z" />
                      </svg>
                    </div>

                    {/* Kolonne 2: Titel og beskrivelse */}
                    <div>
                      <h3 className="text-lg font-bold text-slate-900 mb-2">
                        {item.title}
                      </h3>
                      <p className="text-sm text-slate-600 leading-relaxed mb-4">
                        {item.short_desc}
                      </p>
                      <span className="text-xs font-bold text-sky-600 group-hover:underline inline-block">
                        Læs mere
                      </span>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>

      {/* Action CTA Banner */}
      <section className="py-14 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="p-8 sm:p-10 rounded-2xl bg-slate-900 text-white flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-xl sm:text-2xl font-bold tracking-tight">
                Har du brug for et servicebesøg?
              </h3>
              <p className="text-sm text-slate-300 mt-1">
                Ring direkte og få en uforpligtende snak om din maskine.
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-4">
              <a
                href="tel:69306445"
                className="px-6 py-3 bg-sky-600 hover:bg-sky-500 text-white font-semibold text-sm rounded-lg transition-colors whitespace-nowrap"
              >
                <span className="whitespace-nowrap">Ring 69 30 64 45</span>
              </a>
              <Link
                to="/kontakt"
                className="px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-semibold text-sm rounded-lg transition-colors border border-white/20 whitespace-nowrap"
              >
                Send en forespørgsel
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServicesOverview;
